import type { TPossibleActions, TUpload } from "./types"
import { isSnap } from "./constants"
import { stat } from './Send'
import { TStatEvent } from './types'

export const statOnLoad = (upload: TUpload) => {
    if (!isSnap) return stat({
        action: upload.action,
        event: 'init',
    })
}

export const statOnToken = (action: TPossibleActions, event: TStatEvent = 'token') => {
    if (!isSnap) return stat({
        action: action,
        event: event,
    })
}

export const statFallback = ({
    message,
}: {
    message: string,
}) => {
    // console.log(message)
    return stat({
        event: 'react_error',
    })
}